
import { Component, Prop, Vue } from 'vue-property-decorator'
import { GeoCircle } from '~/utility/geo/GeoLocation'

@Component
export default class LowResultsCitySearch extends Vue {
  @Prop({ required: false })
    area: GeoCircle

  @Prop({ required: true })
    cityName: string

  step = 5
  maxDistanceFromActualWithin = 20
  topDistanceLimit = 95

  get proposedDistances(): number[] {
    const distances: number[] = []
    const range = this.area
      ? this.area.rangeMiles
      : Number(this.$config.public.defaultWithinRange)
    for (
      let index = range + this.step;
      index <= range + this.maxDistanceFromActualWithin &&
      index <= this.topDistanceLimit;
      index += this.step
    ) {
      distances.push(index)
    }
    return distances
  }
}
